import React, { useEffect } from 'react';
import { Table, Typography, Card, Row, Col, Divider, Button } from 'antd';
import { prescriptionAnalyticsData } from '../../data/sampleData';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const PrescriptionAnalytics = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        navigate('/reports');
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [navigate]);

  const columns = [
    { title: 'Medicine', dataIndex: 'medicine', key: 'medicine' },
    { title: 'Times Prescribed', dataIndex: 'prescribed', key: 'prescribed' },
  ];

  return (
    <Row justify="center" style={{ padding: '24px' }}>
      <Col span={24} md={20} lg={16}>
        <Button
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate('/reports')}
          style={{ marginBottom: 16 }}
        >
          Back
        </Button>
        <Card
          title={<Title level={3} style={{ marginBottom: 0 }}>💊 Prescription Analytics</Title>}
          bordered={false}
          style={{ boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}
        >
          <Text type="secondary">Most frequently prescribed medications</Text>
          <Divider />
          <Table
            dataSource={prescriptionAnalyticsData}
            columns={columns}
            rowKey="medicine"
            pagination={{ pageSize: 5 }}
            bordered
          />
        </Card>
      </Col>
    </Row>
  );
};

export default PrescriptionAnalytics;
